import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import DescriptionIcon from '@material-ui/icons/Description';
import {Link} from '@backstage/core-components';
import {entityRouteParams, entityRouteRef,} from '@backstage/plugin-catalog-react';
import {useApp, useRouteRef} from '@backstage/core-plugin-api';
import {Entity, stringifyEntityRef} from '@backstage/catalog-model';
import {useTranslationRef} from '@backstage/frontend-plugin-api';
import {scaffolderReactTranslationRef} from '@backstage/plugin-scaffolder-react/alpha';

export interface TemplateDetailButtonProps {
    template: Entity;
    className?: string;
}

export const AppTemplateDetailButton = ({
                                            template,
                                            className,
                                        }: TemplateDetailButtonProps) => {
    const catalogEntityRoute = useRouteRef(entityRouteRef);
    const { t } = useTranslationRef(scaffolderReactTranslationRef);
    const entityRef = stringifyEntityRef(template);

    const app = useApp();
    const TemplateIcon = app.getSystemIcon('kind:template') || DescriptionIcon;

    return (
        <Tooltip id={`tooltip-${entityRef}`} title={t('cardHeader.detailBtnTitle')}>
            <IconButton
                aria-label={t('cardHeader.detailBtnTitle')}
                id={`viewDetail-${entityRef}`}
                style={{padding: 0}}
            >
                <Typography component="span">
                    <Link
                        to={catalogEntityRoute(entityRouteParams(template))}
                        style={{display: 'flex', alignItems: 'center'}}
                    >
                        <TemplateIcon className={className}/>
                    </Link>
                </Typography>
            </IconButton>
        </Tooltip>
    );
};
